import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';

export interface Activity {
  id: string;
  type: string;
  category: string;
  title: string;
  content: string;
  dateSent: Date;
  dateViewed?: Date;
  expires?: Date;
}

@Injectable({
  providedIn: 'root'
})
export class ActivityService {
  private apiService = inject(ApiService);

  getActivities(updateViewed = false): Observable<Activity[]> {
    return this.apiService.get(`api/activity/?updateViewed=${updateViewed}`);
  }
}
